import React, {FC} from 'react'

import cn from 'classnames/bind'

import {Col, Container, Row} from 'components/elements/grid'
import {Invoice} from 'src/types/__sanitySchema__'

import s from './InvoiceCustomize.module.scss'
import LandingsTitle from '../../LandingsTitle/LandingsTitle'
const cx = cn.bind(s)

interface IInvoiceCustomizeProps {
	className?: string
	content: Invoice['customize']
}

/** InvoiceCustomize block component */
const InvoiceCustomize: FC<IInvoiceCustomizeProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col lg={{span: 10, offset: 1}}>
						<ul className={s.list}>
							{content?.items?.map((item, index) => (
								<li className={s.item} key={item._key || item.title}>
									<h3 className="h3">
										#{index + 1}.&nbsp;&nbsp;
										{item.title}
									</h3>
									<p>{item.description}</p>
								</li>
							))}
						</ul>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

InvoiceCustomize.displayName = 'InvoiceCustomize'

export default InvoiceCustomize
